import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
})
export class PasswordInputComponent {
  @Input() placeholder: string = 'Password'; // Custom placeholder
  @Input() password: string = ''; // Bind password value
  @Input() id: string = 'password'; // Default ID
  @Input() name: string = 'password'; // Default Name
  @Input() tabindex: number = 0; // Keyboard navigation index
  @Input() class: string = ''; // Custom styles for input field
  @Input() ngClass: any; // Custom dynamic class for validation
  @Output() passwordChange = new EventEmitter<string>(); // Output event

  isPasswordVisible: boolean = false;

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
